import FormFields from "./SignUp-SignIn/FormFields";
import FormHeader from "./SignUp-SignIn/FormHeader";
import { Divider, Grid, Paper, Stack, styled, Typography } from "@mui/material";
import { signInFieldsList } from "./SignUp-SignIn/fieldsLists";
import { SignInFormActions } from "./SignUp-SignIn/FormActions";
import { SignInFormFooter } from "./SignUp-SignIn/FormFooter";
import { SignInFormProps } from "../../interfaces/ISginUpSignInForm";
import FlexBanner from "../shared/FlexBanner";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export default function SignInForm({
  formData,
  formErrors,
  onClickSignIn,
  onChange,
  error,
  loading,
}: SignInFormProps) {
  return (
    <Container>
      <Grid container height="100vh" justifyContent="center" alignItems="center">
        <Grid item>
          <Paper sx={{ p: 3 }}>
            <Grid container direction="column" height="auto" spacing={2}>
              <Grid item xs={12} textAlign="center">
                <FormHeader />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Typography fontSize={20} fontWeight={500} lineHeight={1}>
                    Zaloguj się!
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <FormFields
                  fieldDirection="column"
                  fieldsList={signInFieldsList}
                  formData={formData}
                  formErrors={formErrors}
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <SignInFormActions onClickSignIn={onClickSignIn} loading={loading} error={error} />
              </Grid>
              <Grid item>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <SignInFormFooter />
              </Grid>
              <Grid item xs={12}>
                <FlexBanner variant="login" />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
